// Re-export API auth store với shape cũ để ko phải sửa callers
// isAuthed/username vẫn giữ, logout vẫn giữ. Login giờ async qua API.
import { useApiAuth, useLogoutMutation } from '@/modules/auth-api'
import { useMemo } from 'react'

/**
 * Tương thích với authStore cũ (shape {isAuthed, username, login, logout}).
 * - isAuthed = authed thực sự VÀ role === 'ADMIN'
 * - username = user.username (nếu role ADMIN)
 * - login(u, p) không dùng nữa; AdminLoginPage sẽ gọi trực tiếp useLoginMutation
 * - logout() = logout API auth (clear token + user)
 */
export function useAdminAuth<T>(selector: (s: {
  isAuthed: boolean
  username: string | null
  logout: () => void
}) => T): T {
  const user = useApiAuth((s) => s.user)
  const apiAuthed = useApiAuth((s) => s.isAuthed)
  const logoutMut = useLogoutMutation()

  const state = useMemo(() => ({
    isAuthed: apiAuthed && user?.role === 'ADMIN',
    username: apiAuthed && user?.role === 'ADMIN' ? user.username : null,
    logout: () => { logoutMut.mutate() },
  }), [apiAuthed, user, logoutMut])

  return selector(state)
}
